<script setup lang="ts"></script>

<template>
  <icon name="lucide:file-plus" />
</template>

<style scoped></style>
